import { Box, styled } from "@mui/material";

export const StyledGalleryArtMenu = styled(Box)(({ theme }) => ({
  width: "60rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "1rem",
  userSelect: "none",
  h2: {
    color: theme.color.main,
  },
  ".content": {
    display: "flex",
    alignItems: "center",
    gap: "2rem",
    width: "100%",
    justifyContent: "center",
    svg: {
      color: theme.color.contrastColor,
      cursor: "pointer",
    },
    ".selected": {
      color: theme.contrast.lighter,
    },
    ".imageWrapper": {
      width: "40rem",
      height: "40rem",
      overflow: "hidden",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
      },
    },
  },

  ".imagePreviewWrapper": {
    maxWidth: "90%",
    display: "flex",
    gap: "1rem",
    ".imagePreview": {
      width: "3rem",
      background: theme.contrast.lighter,
      height: ".5rem",
      borderRadius: "10px",
      cursor: "pointer",
    },
    ".selected": {
      background: theme.color.contrastColor,
      width: "3.4rem",
      height: ".8rem",
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    width: "100%",
    flexDirection: "column",
    minHeight: "90vh",
    ".content": {
      padding: "0",
      ".caretLeft": {
        position: "absolute",
        left: "1rem"
      },
      ".caretRight": {
        position: "absolute",
        right: "1rem"
      },
      ".imageWrapper": {
        width: "100%",
        height: "fit-content",
      },
    },

    ".imagePreviewWrapper": {
      ".imagePreview": {
        width: "2rem",
        height: ".4rem",
      },
      ".selected": {
        background: theme.color.contrastColor,
        width: "2.4rem",
        height: ".6rem",
      },
    },
  },
}));
